// Never delete originals here: already-sent reports may still reference them.
// replaceInspectionPhoto records their paths for eventual job-purge cleanup.
export async function retakeInspectionPhoto(entry, file, { upload, save }) {
  const replacement = await upload(file);
  await save(entry, replacement);
}
